<template>
    <div>
        <b-modal id="modal-violation" class="maintenance_modal" centered :footer-class="'d-block p-3 m-0'"
            scrollable :body-class="'px-3 pt-2 '">
            <template #modal-header="{ close }">
                <h5 class="modal-title"> {{ violationData ? $t('violation.editTitle') : $t('violation.addTitle') }}
                </h5>
                <b-button size="sm" class="d-none" variant="outline-danger" @click="close()">
                    Close Modal
                </b-button>
            </template>
            <div class="d-block text-center">
                <b-row>
                    <b-col sm="12" class="text-left">
                        <b-form-group>
                            <label class="state">{{ $t('violation.codeLabel') }}</label>
                            <b-form-input class="f-12" type="text" :disabled="!allowUpdateRecord" v-model="violationPayload.code" :placeholder="$t('violation.codePlaceholder')"></b-form-input>
                        </b-form-group>
                        <b-form-group>
                            <label class="state">{{ $t('violation.unitLabel') }}</label>
                            <b-form-select type="text" class="f-12" :disabled="!allowUpdateRecord" v-model="violationPayload.unit" :options="unitOptions"></b-form-select>
                            <p v-if="errors && errors.unit" class="field-error">
                                {{ errors.unit[0] }}
                            </p>
                        </b-form-group>
                        <b-form-group>
                            <label class="state">{{ $t('violation.descriptionLabel') }}</label>
                            <b-form-textarea class="f-12" type="text" :disabled="!allowUpdateRecord" v-model="violationPayload.description" rows="6" :placeholder="$t('violation.descriptionPlaceholder')"></b-form-textarea>
                            <p v-if="errors && errors.description" class="field-error">
                                {{ errors.description[0] }}
                            </p>
                        </b-form-group>
                        </b-col>
                        <b-col sm="12" class="text-left">
                        <!-- <b-form-group>
                            <label class="state">{{ $t('violation.weightLabel') }}</label>
                            <b-form-select type="text" class="f-12" :disabled="!allowUpdateRecord" v-model="violationPayload.weight" :options="[
                                {
                                    value: null,
                                    text: '',
                                },
                                {
                                    value: 1,
                                    text: '1',
                                },
                                {
                                    value: 2,
                                    text: '2',
                                },
                                {
                                    value: 3,
                                    text: '3',
                                }
                            ]"></b-form-select>
                        </b-form-group> -->
                        <!-- <b-form-group>
                            <label class="state">{{ $t('violation.pointsLabel') }}</label>
                            <b-form-input type="number" class="f-12" :disabled="!allowUpdateRecord" v-model="violationPayload.points" :placeholder="$t('violation.pointsPlaceholder')"></b-form-input>
                        </b-form-group> -->
                         <b-form-group>
                            <label class="state">{{ $t('violation.citationNumberLabel') }}</label>
                            <b-form-input type="number" class="f-12" :disabled="!allowUpdateRecord" v-model="violationPayload.citation_number" :placeholder="$t('violation.citationNumberPlaceholder')"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col class="text-left">
                    <b-form-group>
                            <label class="state">{{ $t('violation.oosLabel') }}</label>
                            <b-form-checkbox v-model="violationPayload.oos_status" name="check-button" switch size="lg"
                                class="ml-2" />
                        </b-form-group>
                    </b-col>
                </b-row>
            </div>
            <template #modal-footer>
                <div class="text-right modal-footer border-0 p-0">
                    <b-button class="mt-3 mr-3 btn cancel m-0" block @click="resetPopup()">{{ $t('violation.close') }}</b-button>
                    <div class="d-flex align-items mt-3 m-0">
                        <b-button class="btn save mx-0 w-100" variant="primary" v-if="allowUpdateRecord" @click="onAddViolation">{{ $t('safetyShared.save') }}</b-button>
                    </div>
                </div>
            </template>
        </b-modal>
    </div>
</template>
<script>
import { mapActions } from 'vuex';
export default {
    name: "Violation",
    props: ["inspectionID", "violationData",'allowUpdateRecord'],
    computed: {
        unitOptions() {
            return [
                { value: '', text: '' },
                { value: 'Driver', text: this.$t('violation.unitDriver') },
                { value: 'Vehicle', text: this.$t('violation.unitVehicle') },
                { value: 'Trailer', text: this.$t('violation.unitTrailer') },
            ];
        },
    },
    data() {
        return {
            errors: {},
            violationPayload: {
                code: "",
                description: "",
                unit: "",
                weight: null,
                points: null,
                citation_number: null,
                oos_status: false
            }
        }
    },
    methods: {
        ...mapActions(['addViolation', 'setNotification', 'setLoader', 'updateViolation']),
        resetPopup() {
            this.errors = {}
            this.violationPayload = {
                code: null,
                description: "",
                unit: "",
                weight: null,
                points: null,
                citation_number: null,
                oos_status: false
            }
            this.$bvModal.hide("modal-violation");
        },
        checkNullValues(payload) {
            let nullKeys = [];
            for (let [key, value] of Object.entries(payload)) {
                if (!value) {
                    nullKeys.push(key);
                }
            }
            return nullKeys;
        },
        async onAddViolation() {
            try {
                const nullKeys = this.checkNullValues({
                    description: this.violationPayload.description,
                    unit: this.violationPayload.unit
                });
                if (nullKeys.length === 0) {
                    this.setLoader(true)
                    let successMsg = this.$t('violation.violationAdded')
                    if (this.violationData) {
                        await this.updateViolation({ id: this.inspectionID, payload: { ...this.violationPayload, id: this.violationData.id } })
                        successMsg = this.$t('violation.violationUpdated')
                    }
                    else await this.addViolation({ id: this.inspectionID, payload: this.violationPayload })
                    await this.setNotification({
                        msg: successMsg,
                        type: "success",
                        color: "green",
                    });
                    this.$emit("violationUpdated", true)
                    this.resetPopup()
                    this.setLoader(false)
                }
                else {
                    let error = {};
                    nullKeys.forEach((x) => {
                        error[x] = [this.$t('safetyShared.fieldRequired')];
                    });
                    throw error;
                }
            }
            catch (error) {
                if (typeof error === "object") {
                    this.errors = error;
                    // eslint-disable-next-line no-ex-assign
                }
                this.setLoader(false);
            }
        }
    },
    watch: {
        violationData() {
            if (this.violationData) this.violationPayload = this.violationData
        }
    }
}
</script>